import App from "./App.svelte";
import { SpaRouter } from "svelte-router-spa";
import notFound from "./404.svelte";
import { routes } from "./routes";

SpaRouter({
  routes,
  pathName: document.location.href,
  notFound: notFound
}).getActiveRoute;

const app = new App({
  target: document.querySelector(".container")
});

export default app;
